import { ScrollArea } from "@radix-ui/themes";
import { twMerge } from "tailwind-merge";

export const SideBarContainer = (props: { children: React.ReactNode }) => {
  return (
    <div className="w-full md:w-72 md:px-4 md:mr-4">
      <div
        className={twMerge(
          "md:bg-slate-50 md:dark:bg-slate-900 rounded-lg space-y-1 z-[500] w-[calc(100%-2rem)] top-8 mb-4 md:mb-0 md:top-12 w-full md:w-72 md:fixed md:h-available-screen-height"
        )}
      >
        <ScrollArea
          className="w-full md:h-available-screen-height"
          scrollbars="vertical"
        >
          <div
            className="px-4 flex flex-col h-full"
            style={{
              paddingBottom: "var(--safe-area-bottom)",
            }}
          >
            {props.children}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
};
